import { CARDS } from "@soccertcg/game-engine";
import { DefCard, rarityOf } from "../components/Card.tsx";
import { Logo } from "../components/Logo.tsx";

export function CardShowcasePage() {
  const defs = Object.values(CARDS);
  const picks = [
    { def: defs.find(def => def.role === "field" && rarityOf(def) === "rookie")!, label: "Rookie — clean gloss" },
    { def: defs.find(def => def.role === "field" && rarityOf(def) === "elite")!, label: "Elite — holo sheet" },
    { def: defs.find(def => def.role === "field" && rarityOf(def) === "legend")!, label: "Legend — cosmos foil" },
    { def: defs.find(def => def.role === "goalkeeper")!, label: "Champion — radiant gold" },
    { def: defs.find(def => def.role === "tactic" && def.rarity === "common")!, label: "Common tactic — silver frame" },
    { def: defs.find(def => def.role === "tactic" && def.rarity === "rare")!, label: "Rare tactic — blue holo" },
    { def: defs.find(def => def.role === "tactic" && def.rarity === "legendary")!, label: "Legendary tactic — gold cosmos" },
  ];
  return <div className="showcase-shell">
    <header className="topbar"><Logo/><a className="button ghost" href="/deck-builder">Open deck builder</a></header>
    <main className="showcase-stage">
      <div className="showcase-head"><span className="kicker">THE VAULT</span><h1>Card rarities</h1><p>Move your cursor across a card.</p></div>
      <div className="showcase-row">
        {picks.map(({ def, label }) => <figure key={def.id} className="showcase-card" data-rarity={rarityOf(def)}>
          <DefCard def={def}/>
          <figcaption>{label}</figcaption>
        </figure>)}
      </div>
    </main>
  </div>;
}
